import Button from "@app/sharedComponents/Button/Button";
import { ThemedText, ThemedView } from "@app/theme";
import LottieView from 'lottie-react-native';
import lottie from "../../../../assets/lottie/succes_tick.json"


const EmailSentSuccess = ({isTransactionsEmail=true,closeBottomSheet})=>{
 
    return(
        <ThemedView p="lg" justifyContent="center" alignItems="center">
           <LottieView
                    source={lottie}
                    style={{width: 70, height: 'auto'}}
                    autoPlay={true}
                    loop={true}
                />
            <ThemedText variant="b2m" color="text-primary">Email sent successfully</ThemedText>
            <ThemedText variant="b4r" color="text-secondary" mb="lg">
                {isTransactionsEmail?'Transaction details have been sent to your email address.':'Account holding details have been sent to your email address.'}
            </ThemedText>
            <Button label="Continue" size="MD" type="SOLID" handlePress={closeBottomSheet}/>
        </ThemedView>
    )
}

export default EmailSentSuccess;